module.exports = __webpack_public_path__ + "static/media/KMH_4940.55c78d4f.jpg";